import { colors, dimensions } from '@factorialco/deprecated-design-system'
import { Theme } from '@nivo/core'

const theme = (): Theme => ({
  axis: {
    ticks: {
      line: {
        strokeWidth: 0,
      },
      text: {
        color: colors.grey800,
        fontSize: dimensions.s12,
        outlineWidth: 2,
      },
    },
  },
  grid: {
    line: {
      stroke: colors.grey400,
      strokeWidth: dimensions.s2,
      strokeDasharray: '4 4',
    },
  },
})

export default theme
